import request from "@/api/request";
/**
 * 登录接口请求token与userinfo
 * @param params {code: code}
 */

export function loginByCode(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/url',
    method: 'get',
    params: params
  });
}
export function wechatPay(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wechatConf/wechatPay',
    method: 'post',
    params: params
  });
}
export function wechatConfig(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wechatConf/wechatConfig',
    method: 'post',
    params: params
  });
} //统一下单-统一接口(JSAPI支付)

export function transactions(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wechatPay/transactions',
    method: 'post',
    params: params
  });
} //申请退款-统一接口

export function refundOrder(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wechatPay/refundOrder',
    method: 'post',
    params: params,
    hideLoading: true
  });
} //查询单笔退款信息

export function queryRefundOrder(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wechatPay/queryRefundOrder',
    method: 'get',
    params: params,
    hideLoading: true
  });
} //支付宝下单

export function getAlipayFormParams(params) {
  return request({
    url: window.g.VUE_APP_URL_AUTH + '/wapaliPay/getAlipayFormParams',
    method: 'post',
    params: params
  });
}